<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" v-model="selectedItems" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" show-select loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense>
						<v-col cols="12" class="d-flex">
							<div style="width: 250px;" class="mr-1">
								<v-autocomplete :items="selectClassList" v-model="query.classId" item-text="className"
									item-value="id" label="班级" dense outlined clearable no-data-text="无数据"></v-autocomplete>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-select :items="selectTeacherList" v-model="query.teacher" item-text="trueName"
									item-value="id" label="老师" dense outlined clearable></v-select>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-select :items="selectClassroomList" v-model="query.roomId" item-text="roomName"
									item-value="id" label="教室" dense outlined clearable></v-select>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-select :items="weekItems" v-model="query.weekAt" item-text="weekName"
									item-value="week" label="周几" dense outlined clearable></v-select>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									 transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="上课开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
										
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="上课结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
											
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName"
									item-value="id" label="状态" dense outlined></v-select>
							</div>
							<v-btn @click="selectData" color="primary">查询</v-btn>
						</v-col>
						
		
						<v-col cols="12" class="d-flex mt-n4">
							<v-btn small @click="showAddDialog" color="info" class="ml-0">添加排课</v-btn>
							
							<v-btn small @click="batchCancel" color="error" class="ml-3">批量取消排课</v-btn>
							
							<v-btn small @click="toBatchDelay" color="warning" class="ml-3">批量顺延</v-btn>
						</v-col>
					</v-row>
				</template>
				<template v-slot:item.status="{item}">
					<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
					</v-chip>
				</template>
				<template v-slot:item.timeRange="{item}">
					<v-chip small color="success">
						{{ item.timeFrom }} - {{item.timeTo}}
					</v-chip>
				</template>
				<template v-slot:item.weekAt="{item}">
					<v-chip small color="warning">{{ weekName(item.weekAt) }}
					</v-chip>
				</template>
				<template v-slot:item.action="{item}">
					<v-menu top>
						<template v-slot:activator="{ attrs, on }">
							<v-btn color="primary" v-bind="attrs" v-on="on" small>
								操作
							</v-btn>
						</template>
						<v-list>
							<v-list-item class="justify-center">
								<v-btn @click="showUpdateDialog(item)" :disabled="item.status !== '1'" color="info" small>修改课次</v-btn>
							</v-list-item>
							<v-list-item class="justify-center">
								<v-btn @click="showApproveDialog(item)" :disabled="item.status !== '1'" color="orange" small>核销课次</v-btn>
							</v-list-item>
							<v-list-item>
								<v-btn @click.stop="delayRecord(item)" :disabled="item.status !=='1' " color="error" small>顺延课次</v-btn>
							</v-list-item>
							<v-list-item>
								<v-btn @click.stop="undoDelayRecord(item)" :disabled="item.status !=='3' " color="success" small>撤销顺延</v-btn>
							</v-list-item>
							<v-list-item>
								<v-btn @click="frozenRecord(item)" :disabled="item.status !== '1'" color="error" small>取消课次</v-btn>
							</v-list-item>
							<v-list-item>
								<v-btn @click.stop="freeRecord(item)" :disabled="item.status !=='0' " color="success" small>启用课次</v-btn>
							</v-list-item>
						</v-list>
					</v-menu>
				</template>
				
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
		<!-- 添加排课 dialog -->
		<v-dialog title="给班级添加排课" v-model="add.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>给班级添加排课</v-card-title>
				<v-card-text>
					<v-row class="mb-2 mt-2" rounded>
						<v-col cols="12">
							<v-alert dense type="info">用于给班级增加排课</v-alert>
						</v-col>
					</v-row>
					<v-row dense>
						
						<v-col cols="6">
							<v-select :items="selectClassList" v-model="add.record.classId" item-text="className"
								item-value="id" label="班级" @change="addClassChanged" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectTeacherList" v-model="add.record.teacher" item-text="trueName"
								item-value="id" label="老师" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectClassroomList" v-model="add.record.roomId" item-text="roomName"
								item-value="id" label="教室" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-menu ref="menuclassDate" v-model="add.classDateMenu" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.record.classDate" label="开始上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="add.record.classDate" locale="zh-cn" 
									@input="add.classDateMenu=false" no-title scrollable></v-date-picker>								
							</v-menu>
						</v-col>
						<v-col cols="6">
							<v-select v-model="add.record.weekAt" :items="weekItems" label="周几上课"
								item-text="weekName" item-value="week" outlined dense></v-select>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :nudge-right="40"
								:return-value.sync="add.record.timeFrom" transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.record.timeFrom" label="上课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu3" v-model="add.record.timeFrom" full-width format="24hr"
									@click:minute="$refs.menu3.save(add.record.timeFrom)"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" :nudge-right="40"
								:return-value.sync="add.record.timeTo" transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.record.timeTo" label="下课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu4" v-model="add.record.timeTo" full-width format="24hr"
									@click:minute="$refs.menu4.save(add.record.timeTo)"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="6">
							<v-text-field label="排课次数" type="number" v-model="add.record.lessonCount" dense outlined>
							</v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddRecord" :disabled="add.submitting" :loading="add.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 单条修改 dialog -->
		<v-dialog title="修改排课" v-model="update.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>修改排课</v-card-title>
				<v-card-text>
					<v-row dense>
						
						<v-col cols="6">
							<v-select :items="selectClassList" v-model="update.record.classId" disabled item-text="className"
								item-value="id" label="班级" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectTeacherList" v-model="update.record.teacher" item-text="trueName"
								item-value="id" label="老师" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectClassroomList" v-model="update.record.roomId" item-text="roomName"
								item-value="id" label="教室" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-menu ref="menuclassDate" v-model="update.classDateMenu" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.record.classDate" label="上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="update.record.classDate" locale="zh-cn" 
									@input="update.classDateMenu=false" no-title scrollable></v-date-picker>								
								
							</v-menu>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu5" v-model="menu5" :close-on-content-click="false" :nudge-right="40"
								:return-value.sync="update.record.timeFrom" transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.record.timeFrom" label="上课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu5" v-model="update.record.timeFrom" full-width format="24hr"
									@click:minute="$refs.menu5.save(update.record.timeFrom)"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu6" v-model="menu6" :close-on-content-click="false" :nudge-right="40"
								:return-value.sync="update.record.timeTo" transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.record.timeTo" label="下课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu6" v-model="update.record.timeTo" full-width format="24hr"
									@click:minute="$refs.menu6.save(update.record.timeTo)"></v-time-picker>
							</v-menu>
						</v-col>

					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="update.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdateRecord" :disabled="update.submitting" :loading="update.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		

		<!-- 批量删除 dialog -->
		<v-dialog title="批量取消" v-model="batchDelete.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>批量取消排课</v-card-title>
				<v-card-text>
					<v-row class="mb-2 mt-2" rounded>
						<v-col cols="12">
							<v-alert dense type="warning">选中的{{selectedItems.length}}条排课记录都将会被取消</v-alert>
						</v-col>
						<v-col cols="12" class="mt-n3">
							<span style="font-size:16px">是否确认取消排课记录？</span>
						</v-col>
					</v-row>
					
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="batchDelete.dialog=false">放弃</v-btn>
					<v-btn @click="submitBatchDelete" :disabled="batchDelete.submitting" :loading="batchDelete.submitting" color="success">确定取消</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 批量顺延 dialog -->
		<v-dialog title="批量顺延" v-model="batchDelay.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>批量顺延课次</v-card-title>
				<v-card-text>
					<v-row class="mb-2 mt-2" rounded>
						<v-col cols="12">
							<v-alert dense type="warning">选中的{{selectedItems.length}}条排课记录都将会被顺延</v-alert>
						</v-col>
						<v-col cols="12" class="mt-n3">
							<span style="font-size:16px">是否确认顺延排课记录？</span>
						</v-col>
					</v-row>
					
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="batchDelay.dialog=false">放弃</v-btn>
					<v-btn @click="submitBatchDelay" :disabled="batchDelay.submitting" :loading="batchDelay.submitting" color="success">确定顺延</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 核销组件 -->
		<approveRecord :show="approve.show" :recordId="approve.recordId" @cancel="approve.show=false" @success="approveSuccess"></approveRecord>
	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	import approveRecord from "../../../components/approve_record.vue"
	export default {
		name: "class-record-list",
		components:{approveRecord},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				menu3:false,  // add 上课时间menu
				menu4:false,  // add 下课时间menu
				menu5:false,  // update 上课时间menu
				menu6:false,  // update 下课时间menu
				global:global,
				selectedItems:[], //选中的行
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '排课明细',
						disabled: true
					},
				],
				imgPrev: global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '上课日期',
							value: 'classDate',
							sortable: false
						},
						{
							text: '周几',
							value: 'weekAt',
							sortable: false
						},
						{
							text: '上课时段',
							value: 'timeRange',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '应/实/假/旷',
							value: 'unionCount',
							sortable: false
						},
						{
							text: '消课时',
							value: 'totalReduceQty',
							sortable: false
						},
						{
							text: '消学费',
							value: 'totalReduceFee',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				selectTeacherList: [], //选择老师数据源
				selectClassroomList: [], //选择教室数据源
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"待核销"},
					// {id:"0",statusName:"已取消"},
					{id:"2",statusName:"已核销"},
					{id:"3",statusName:"已顺延"},
				],
				weekItems:global.weekList,
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					classId: "",
					roomId: "",
					teacher: "",
					status:"1",
					weekAt:""
				},
				add: {
					dialog: false,
					classDateMenu:false,
		
					submitting:false,
					record: {
						classId: "",
						teacher: "",
						roomId:"",
						classDate:"",
						timeFrom:"",
						timeTo:"",
						weekAt:"",
						lessonCount:""
					},
				},
				update: {
					dialog: false,
					classDateMenu:false,
					submitting:false,
					record: {
						classId: "",
						teacher: "",
						roomId:"",
						classDate:"",
						timeFrom:"",
						timeTo:"",
					},
				},
				batchDelete:{
					dialog: false,
					submitting:false,
				},
				batchDelay:{
					dialog: false,
					submitting:false,
				},
				approve:{
					// 核销组件控制
					show:false,
					recordId:"",

				}
			}
		},
		created() {
			// 获取门店列表
			this.getTableDataList();
			const shopId = utils.getCurrentShopId();
			this.getClassListForSelect(shopId);
			this.getClassroomListForSelect(shopId);
			this.getTeacherListForSelect(shopId);
		},
		methods: {
			openPage(path){
				console.log("open path:"+path);
				this.$router.push(path);
			},
			selectData(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			addClassChanged(){
				//选择了班级
				
				this.selectClassList.forEach((item,index)=>{
					if(item.id === this.add.record.classId){
						console.log(item);
						this.add.record.teacher = item.teacher;
						this.add.record.roomId = item.roomId;
						this.add.record.timeFrom = item.timeFrom;
						this.add.record.timeTo = item.timeTo;
						
					}
				})
				
			},
			
			batchUpdateShopChanged() {
				this.selectClassList = [];
				this.selectClassroomList = [];
				this.selectTeacherList = [];
				if (this.batchUpdate.record.shopId) {
					this.getClassListForSelect(this.batchUpdate.record.shopId);
					this.getClassroomListForSelect(this.batchUpdate.record.shopId);
					this.getTeacherListForSelect(this.batchUpdate.record.shopId);
				}
			},
			
			showAddDialog() {
				this.add.dialog = true;

				// 清空add历史数据
				this.add.record.classId = "";
		
				this.add.record.teacher = "";
				this.add.record.roomId = "";
				this.add.record.classDate = "";
				this.add.record.timeFrom = "";
				this.add.record.timeTo = "";
				

			},
			showUpdateDialog(item) {
				
				console.log(item);
				this.update.dialog = true;
			
				this.update.record.id = item.id;
	
				this.update.record.classId = item.classId;
				this.update.record.teacher = item.teacher;
				this.update.record.roomId = item.roomId;
				this.update.record.classDate = item.classDate;
				this.update.record.timeFrom = item.timeFrom;
				this.update.record.timeTo = item.timeTo;
				
				
		
			
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/edu/class/record/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				
				if (this.query.roomId) {
					url += "&roomId=" + this.query.roomId;
				}
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				if (this.query.weekAt) {
					url += "&weekAt=" + this.query.weekAt;
				}
				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}else if (response.data["code"] === 7031){
						// 调整到登录页
						that.$router.push('/login');
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			weekName(wk) {

				let stName = "未知";
				this.weekItems.forEach((item,index)=>{
					if (item.week == wk){
						stName = item.weekName;
						
					}
				})
				return stName;
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "待核销";
				} else if (state === "0") {
					stName = "已取消";
				}else if (state === "2") {
					stName = "已核销";
				}else if (state === "3") {
					stName = "已顺延";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "grey";
				}

				return color;
			},
			consumeTypeColor(state){
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "success";
				}
				
				return color;
			},
			consumeTypeName(state){
				let color = "未知";
				if (state === "1") {
					color = "扣课时";
				} else if (state === "2") {
					color = "扣金额";
				}
				
				return color;
			},
			submitAddRecord() {

				
				if (!this.add.record.classId) {
					this.$noty.error('班级不能为空');
					return
				}
			
				if (!this.add.record.classDate) {
					this.$noty.error('上课日期不能为空');
					return
				}
				
				if (!this.add.record.roomId) {
					this.$noty.error('教室不能为空');
					return
				}
				if (!this.add.record.teacher) {
					this.$noty.error('老师不能为空');
					return
				}
				if (!this.add.record.timeFrom) {
					this.$noty.error('上课开始时刻不能为空');
					return
				}
				
				if (!this.add.record.timeTo) {
					this.$noty.error('上课结束时刻不能为空');
					return
				}
				
				if (!this.add.record.weekAt) {
					this.$noty.error('周几上课不能为空');
					return
				}
				
				if (!this.add.record.lessonCount) {
					this.$noty.error('排课次数不能为空');
					return
				}
				
				
				this.add.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/create`;
				let postData = {
					...this.add.record
				};
				postData.shopId = utils.getCurrentShopId();

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							that.add.submitting = false;
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}

				});
			},
			submitUpdateRecord() {
			
			
				if (!this.update.record.classId) {
					this.$noty.error('班级不能为空');
					return
				}
			
				if (!this.update.record.classDate) {
					this.$noty.error('上课日期不能为空');
					return
				}
				
				if (!this.update.record.roomId) {
					this.$noty.error('教室不能为空');
					return
				}
				if (!this.update.record.teacher) {
					this.$noty.error('老师不能为空');
					return
				}
				if (!this.update.record.timeFrom) {
					this.$noty.error('上课开始时刻不能为空');
					return
				}
				if (!this.update.record.timeTo) {
					this.$noty.error('上课开始时刻不能为空');
					return
				}
				
				this.update.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/update`;
				let postData = {
					...this.update.record
				};
				postData.shopId = utils.getCurrentShopId();
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getTableDataList();
							that.update.dialog = false;
							that.update.submitting = false;
							return;
						} else {
							that.update.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submitting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			},
			showBatchUpdateDialog(){
				
				if (this.selectedItems.length == 0){
					this.$noty.error('至少选择一条数据');
					return
				}
				this.batchUpdate.dialog = true;
				
			},
			batchCancel(){
				if (this.selectedItems.length == 0){
					this.$noty.error('至少选择一条数据');
					return
				}
				this.batchDelete.dialog = true;
				console.log(this.selectedItems);
			},
			toBatchDelay(){
				if (this.selectedItems.length == 0){
					this.$noty.error('至少选择一条数据');
					return
				}
				this.batchDelay.dialog = true;
				
			},
			submitBatchDelete(){
				//批量取消
				if (this.selectedItems.length == 0){
					this.$noty.error('没有选中的数据');
					return
				}
				let ids = [];
				this.selectedItems.forEach((item,index)=>{
					ids.push(item.id);
				});
				
				
				
				this.batchDelete.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/batch/cancel`;
				
				let postData = {}
				postData.ids = ids;
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getTableDataList();
							that.batchDelete.dialog = false;
							that.batchDelete.submitting = false;
							that.selectedItems = [];
							return;
						} else {
							that.batchDelete.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.batchDelete.submitting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
			submitBatchDelay(){
				//批量顺延
				if (this.selectedItems.length == 0){
					this.$noty.error('没有选中的数据');
					return
				}
				let ids = [];
				this.selectedItems.forEach((item,index)=>{
					
					ids.push(item.id);
				});
				
				this.batchDelay.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/batch/delay`;
				
				let postData = {}
				postData.ids = ids;
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getTableDataList();
							that.batchDelay.dialog = false;
							that.batchDelay.submitting = false;
							that.selectedItems = [];
							return;
						} else {
							that.batchDelay.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.batchDelay.submitting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
			frozenRecord(item){
				// 取消排课记录
				const that = this;
				let url = `/edu/class/record/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freeRecord(item){
				// 启用排课记录
				const that = this;
				let url = `/edu/class/record/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			delayRecord(item){
				// 顺延排课记录
				const that = this;
				let url = `/edu/class/record/delay/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			undoDelayRecord(item){
				// 撤销顺延排课记录
				const that = this;
				let url = `/edu/class/record/delay/undo/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			
			getClassListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/class/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect(shopId){
				
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/course/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect(shopId){
				
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/teacher/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassroomListForSelect(shopId){
				
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/classroom/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectClassroomList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			showApproveDialog(item){
			
				this.approve.recordId = item.id;
				this.approve.show = true;
				
			},
			approveSuccess(){
				this.approve.show=false;
				this.getTableDataList();
			},
			
			
		}
	}
</script>

<style>
</style>
